import { useCallback, useState } from "react";
import { actualizarEntrega } from "../../../services/backend/deliveryService";

const useDeliveryMethod = ({ cotizacionId, onRefreshCheckoutSummary, onShowToast }) => {
  const [deliveryMethod, setDeliveryMethod] = useState("pickup");

  const handleDeliveryMethodChange = useCallback(async (nextMethod) => {
    const normalizedMethod = nextMethod === "delivery" ? "delivery" : "pickup";
    setDeliveryMethod(normalizedMethod);
    if (!cotizacionId) return;
    try {
      await actualizarEntrega(cotizacionId, normalizedMethod === "delivery" ? 4 : 3);
      onRefreshCheckoutSummary?.();
    } catch (error) {
      const message = error?.message || "No fue posible actualizar el tipo de entrega.";
      onShowToast?.({ severity: "error", summary: "Entrega", detail: message, life: 4000 });
    }
  }, [cotizacionId, onRefreshCheckoutSummary, onShowToast]);

  return {
    deliveryMethod,
    handleDeliveryMethodChange,
  };
};

export default useDeliveryMethod;